export default {"src":"/_next/static/media/left-red-dot.ddd02aa1.svg","height":12,"width":20};